import React from "react";
import PropTypes from "prop-types";
import { Slot } from "./Slot";

import "./style.scss";

const VISIBLE_POSITIONS = [11, 12, 1, 2, 3];
const TRANSFER_KEY = "MC_ITEM";

export function TopSection(props) {
  const renderSlots = (slotId) => {
    const getSlotProps = () => props.slots.find((slot) => slot.id === slotId);
    return (
      <Slot
        className="mc_topSection_slot"
        position={slotId}
        {...getSlotProps()}
      />
    );
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const onDrop = (event) => {
    event.preventDefault();
    const data = JSON.parse(event.dataTransfer.getData(TRANSFER_KEY));
    console.log("got it", data);
    props.onItemDropCentrifuge(data);
    // props.onDrop({droppedId: droppedId, locationId: props.id});
  };

  return (
    <div
      className={`mc_topSection ${props.className}`}
      onClick={props.onClick}
      onDragOver={onDragOver}
      onDrop={onDrop}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          props.onClick;
        }
      }}
    >
      {VISIBLE_POSITIONS.map(renderSlots)}
    </div>
  );
}

TopSection.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * callback function to trigger on click
   */
  onClick: PropTypes.func,
  /**
   * list of slot information for each slot in microcentrifuge
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id for unique identification
       */
      id: PropTypes.number,
      /**
       *  specifies if solution is present
       */
      solution: PropTypes.bool,
      /**
       * specfies if rotor is present
       */
      rotor: PropTypes.bool,
    })
  ),
};

TopSection.defaultProps = {
  className: "",
};
